import { style } from "@vanilla-extract/css";
import { textTruncate, vars } from "plos/src/styles";

export const topElementWrap = style({
  borderRadius: vars.radii.s,
  backgroundColor: vars.colors.surfaceVariant,
});

export const topElementStyles = style({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
  padding: 1,
  width: 95,
});

export const topElementPhotoContainer = style({
  margin: `${vars.space["2xs"]} auto 0`,
  width: 54,
});

export const topElementName = style([
  textTruncate,
  {
    borderRadius: "3px 3px 0 0",
    backgroundColor: vars.colors.surface,
    padding: `2px ${vars.space.xs}`,
    textAlign: "center",
    fontFamily: vars.fonts.bold,
    fontSize: vars.fontSizes.body.xs,
  },
]);

export const topElementValue = style({
  position: "relative",
  display: "flex",
  justifyContent: "space-between",
  borderRadius: "0 0 3px 3px",
  background: vars.colors.blueBrandGradient,
  padding: `2px ${vars.space.xs}`,
  color: vars.colors.primaryFixed,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.xs,
  selectors: {
    '[dir="rtl"] &': {
      background: vars.colors.blueBrandGradientRtl,
    },
  },
});
